/**
 * Tiny classname combiner. Filters out falsy values so you can write
 * cx(s.btn, isActive && s.active, className).
 */
export function cx(...parts) {
  return parts.filter(Boolean).join(' ');
}

export default cx;
